
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.805 17.316l-8.484-6.557c1.556-.55 2.678-2.015 2.678-3.759a4 4 0 00-4-4C8.902 3 7.202 4.619 7.033 6.669L2.421 3.106a.502.502 0 00-.703.088l-.613.787a.498.498 0 00.088.7l18.387 14.21a.502.502 0 00.703-.088l.613-.79a.495.495 0 00-.09-.697zM4 16.2v1.3A1.5 1.5 0 005.5 19h10.944L7.48 12.072A4.194 4.194 0 004 16.2z","fill":"#282498","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_user_slash.svg